// Range sliders of the CalcRange / CalcCharge / CalcSavings articles. Called by the
// components through JS interop once they have rendered.

window.initRange = (articleId) => {
    const q = (sel) => document.querySelector(`#article-${articleId} ${sel}`);

    mag.doubleRangeSlider(q('#range1'), q('#range2'), q('#val1'), q('#val2'), q('#val3'), true);
    mag.singleRangeSlider(q('#range3'), q('#val4'), '&deg;C', true);
};

window.initCharge = (articleId) => {
    const q = (sel) => document.querySelector(`#article-${articleId} ${sel}`);

    mag.singleRangeSlider(q('#range1'), q('#val1'), '%', true);
    mag.singleRangeSlider(q('#range2'), q('#val2'), '&deg;C', true);
};

window.initSavings = (articleId) => {
    const q = (sel) => document.querySelector(`#article-${articleId} ${sel}`);

    mag.singleRangeSlider(q('#range1'), q('#val1'), 'km', true);
    mag.singleRangeSlider(q('#range2'), q('#val2'), '&nbsp;jaar', true);
};

mag.singleRangeSlider = (r, v, unit, init) => {
    if (!r || !v) {
        return;
    }
    if (init) {
        r.addEventListener('input', () => mag.singleRangeSlider(r, v, unit, false));
    }

    const rval = parseFloat(r.value);
    v.innerHTML = `${rval.toLocaleString('nl-NL')}${unit}`;
};

// Two range inputs sharing one track: city / rural / highway split of the CalcRange article
mag.doubleRangeSlider = (r1, r2, v1, v2, v3, init) => {
    if (!r1 || !r2 || !v1 || !v2 || !v3) {
        return;
    }
    if (init) {
        r1.addEventListener('input', () => mag.doubleRangeSlider(r1, r2, v1, v2, v3, false));
        r2.addEventListener('input', () => mag.doubleRangeSlider(r1, r2, v1, v2, v3, false));
    }

    const precision = 2;

    const slider = '20px';
    const r1min = parseFloat(r1.min);
    const r2max = parseFloat(r2.max);
    const r1step = parseFloat(r1.step) || 1;
    const r1val = parseFloat(r1.value);
    const r2val = parseFloat(r2.value);
    const rvaldiff = (r2val - r1val) / 2;
    const rminmax = r1val + Math.ceil(rvaldiff / r1step) * r1step;
    const rdiff = r2max - r1min;
    const r1width = ((rminmax - r1min) / rdiff * 100).toFixed(precision);
    const r2width = ((r2max - rminmax) / rdiff * 100).toFixed(precision);

    r1.style.flexBasis = `calc(${r1width}% + ${slider})`;
    r2.style.flexBasis = `calc(${r2width}% + ${slider})`;
    r1.max = rminmax.toFixed(precision);
    r2.min = rminmax.toFixed(precision);

    const minFill = (r1val - r1min) / (rminmax - r1min) || 0;
    const maxFill = (r2val - rminmax) / (r2max - rminmax) || 0;
    const minFillPercentage = (minFill * 100).toFixed(precision);
    const maxFillPercentage = (maxFill * 100).toFixed(precision);
    const minFillThumb = (0.5 - minFill).toFixed(precision);
    const maxFillThumb = (0.5 - maxFill).toFixed(precision);

    r1.style.setProperty('--dri-gradient-position', `calc(${minFillPercentage}% + (${minFillThumb} * ${slider}))`);
    r2.style.setProperty('--dri-gradient-position', `calc(${maxFillPercentage}% + (${maxFillThumb} * ${slider}))`);

    v1.innerHTML = `stad<br>${r1val}%`;
    v2.innerHTML = `buitenweg<br>${r2val - r1val}%`;
    v3.innerHTML = `snelweg<br>${100 - (r2val - r1val) - r1val}%`;
};
